angular.module('NiacsProjectApp.controllers-dashboard', [
])
.controller('MyAccountCtrl',['$scope','$window',function($scope,$window) {
    $scope.editAccount = function() {
        if($scope.userProfile && $scope.userProfile.id) {
            $window.location.href='/user/'+$scope.userProfile.uid+'/edit';
        }
    };
}])
.controller('ProjectDialogCtrl',['$scope','$uibModalInstance','$http','$timeout','$filter','$document','$log','NiacsVulnAssmntRegion','NiacsStrategyService','ProjectService','theProject',
    function($scope,$uibModalInstance,$http,$timeout,$filter,$document,$log,NiacsVulnAssmntRegion,NiacsStrategyService,ProjectService,theProject){
    $document.bind('keypress', function(e) {
        if(e.ctrlKey && e.shiftKey && ((e.charCode == 4 || e.key == "D") || (e.key === "L")) /*d*/) {
          $scope.$apply(function(){
            niacs.DEBUG = !niacs.DEBUG;
          });
        }
    });
    $scope.hideStrategies = true; // o/w it will flash
    $scope.project = theProject;
    $scope.mapShowHide = { show: true };
    $scope.detailsShowHide = { show: true };
    NiacsStrategyService.getSources().then(function(sources){
        $scope.strategySources = sources.filter(function(s) {
            return !s.isDisabled() && s.getSource() !== 'niacs_strategy'; // don't let them pick FAR1
        });
        $scope.strategySourceMap = $scope.strategySources.reduce(function(map,s){
            map[s.getSource()] = s;
            return map;
        },{});
    });
    function setFeatureStyle(feature,style,prop,dflt) {
        var value = feature.getProperty(prop);
        if(value) {
            style[prop] = value;
        } else if (dflt) {
            style[prop] = dflt;
        }
        return style;
    }
    function geoContains(point,geo) {
        var polyType = geo.getType(),
            poly,arr,i;
        if(polyType == 'Polygon') {
            poly = new google.maps.Polygon({paths: geo.getArray()[0].getArray()});
            return google.maps.geometry.poly.containsLocation(point,poly) ||
                   google.maps.geometry.poly.isLocationOnEdge(point,poly);
        } else if (polyType === 'MultiPolygon' || polyType == 'GeometryCollection') {
            arr = geo.getArray();
            for(i = 0; i < arr.length; i++) {
                if(geoContains(point,arr[i])) {
                    return true;
                }
            }
        }
        return false;
    }
    function geoNearest(features,point) {
        var toleranceDecr = 0.1;
        var tolerance = 0.3 + toleranceDecr; // start at 0.3
        var geoNear;
        var geoNearGenerator = function(tolerance) {
            return function(point,geo) {
                var lat = point.lat();
                var lng = point.lng();
                var south = new google.maps.LatLng(lat-tolerance, lng);
                var north = new google.maps.LatLng(lat+tolerance, lng);
                var east = new google.maps.LatLng(lat, lng+tolerance);
                var west = new google.maps.LatLng(lat, lng-tolerance);
                return [south,north,west,east].reduce(function(carry,point) {
                        return carry||geoContains(point,geo);
                    },false);
            };
        };
        var filterFunctor = function(feature) {
            return geoNear(point,feature.getGeometry(),tolerance);
        };
        var near = [];
        do {
            tolerance -= toleranceDecr;
            geoNear = geoNearGenerator(tolerance);
            var nearer = (near.length ? near : features).filter(filterFunctor);
            if(nearer.length) {
                near = nearer;
            }
        } while(near.length !== 1 && tolerance > toleranceDecr);
        if(near.length > 1) {
            console.log('nearest results ambiguous, found '+near.length);
        }
        return near.length > 0 ? near[0] : null;
    }
    function _markerMoved() {
        var latLn = $scope.marker.getPosition();
        var nearest,niacsRegion,state,name;
        $scope.map.panTo(latLn);
        $scope.project.lat = latLn.lat();
        $scope.project.lon = latLn.lng();
        $scope.project.state = null;
        $scope.project.vuln_region = $scope.project.$vuln_region = null;
        $scope.status_warning = undefined;
        $scope.map.data.forEach(function(feature){
            if(geoContains(latLn,feature.getGeometry())) {
                if((state = feature.getProperty('STATE')) && (name = feature.getProperty('NAME'))) {
                    $log.debug("Selected state",name);
                    $scope.project.state = null;
                    angular.forEach($scope.vocab_state,function(state){
                        if(name == state.label) {
                            $scope.project.state = state.id;
                        }
                    });
                } else if (niacsRegion = feature.getProperty('niacsRegion')) {
                    $scope.project.vuln_region = niacsRegion.id;
                    $scope.project.$vuln_region = niacsRegion;
                }
            }
        });
        if($scope.project.state && !$scope.project.vuln_region) {
            // they picked an area outside of a specific niacs region
            // see if there is one defined for the state they did pick
            var state_name = $filter('niacsTerm')($scope.project.state,$scope.vocab_state);
            NiacsVulnAssmntRegion.query({'filter[field_niacs_state.name]': state_name},function(regions){
                if(regions && regions.list && regions.list.length === 1) {
                    $scope.project.vuln_region = regions.list[0].id;
                    $scope.project.$vuln_region = regions.list[0];
                } else {
                    $scope.status_warning = "Unable to determine the vulnerability assessment region for " + state_name;
                }
            });
        } else {
            if(!$scope.project.vuln_region) {
                $log.debug('No VAR selected, testing buffered');
                nearest = geoNearest($scope.varFeatures,latLn);
                if(nearest && (niacsRegion = nearest.getProperty('niacsRegion'))) {
                    $log.debug('Found near VAR',niacsRegion);
                    $scope.project.vuln_region = niacsRegion.id;
                    $scope.project.$vuln_region = niacsRegion;
                } else {
                    $log.debug('No near VAR found');
                }
            }
            if ($scope.project.vuln_region && !$scope.project.state) {
                $log.debug('VAR found but no state, testing buffered');
                if((nearest = geoNearest($scope.stateFeatures,latLn)) && 
                    (state = nearest.getProperty('STATE')) &&
                    (name = nearest.getProperty('NAME'))) {
                    $log.debug('Found near state',name);
                    $scope.project.state = null;
                    angular.forEach($scope.vocab_state,function(state){
                        if(name == state.label) {
                            $scope.project.state = state.id;
                        }
                    });
                }
            }
            if (!$scope.project.state || !$scope.project.vuln_region) {
                $scope.status_warning = "Currently, the Adaptation Workbook provides climate change information only for projects located in the United States. You can proceed with this project location, but you will need to input your own climate change impact information for this region.";
            }
        }
    }
    function markerMoved() {
        $scope.$apply(_markerMoved);
    }
    // loads a list of geojson files serially.
    function doLoadGeoJson () {
        if($scope.geoJsonToLoad.length === 0) {
            $scope.loadStatus = null;
            $scope.map.data.setStyle(function(feature) {
                var style = {clickable: false},
                    niacsRegion = feature.getProperty('niacsRegion');
                if(niacs.DEBUG) {
                    setFeatureStyle(feature,style,'strokeColor','#ffffff');
                    setFeatureStyle(feature,style,'strokeOpacity',null);
                    setFeatureStyle(feature,style,'strokeWeight',1);
                    setFeatureStyle(feature,style,'fillColor','#c0c5b8');
                    setFeatureStyle(feature,style,'fillOpacity',null);
                } else {
                    // customer doesn't want regions styled.
                    style['strokeOpacity'] = 0;
                    style['fillOpacity'] = 0;
                }
                if(niacsRegion) {
                    $log.debug("Styling region '"+niacsRegion.label+"' with id "+niacsRegion.id,style);
                }
                return style;
            });
            if($scope.project.id) {
                // in case not yet migrated
                if(!$scope.project.strategy_sources) {
                    $scope.project.strategy_sources = ['niacs_strategy'];
                }
                ProjectService.setProject($scope.project); // for custom text
                // put a marker on the map where their property is, period.
                $scope.marker = new google.maps.Marker({
                    position: new google.maps.LatLng($scope.project.lat, $scope.project.lon),
                    map: $scope.map,
                    title: $scope.project.label,
                    draggable: false
                });
                $scope.map.panTo($scope.marker.getPosition());
                $timeout(function(){$scope.map.setZoom(8);},500);
            } else {
                $scope.project.strategy_sources = ['niacs_strategy_far2'];
                ProjectService.setProject($scope.project); // for custom text
                // used to be $scope.map.data.addListener to restrict to where there are features on the map
                // but now users can drop markers anywhere.
                $scope.map.addListener('click',function(event){
                    $log.debug('data.click',event);
                    if(!$scope.marker) {
                        $scope.marker = new google.maps.Marker({
                            position: event.latLng,
                            map: $scope.map,
                            title: 'Your Property Center',
                            draggable: true,
                            animation: google.maps.Animation.DROP
                        });
                        google.maps.event.addListener($scope.marker, 'dragend', markerMoved);
                        markerMoved();
                    }
                });
            }
            // don't show strategies for "legacy" projects
            // first release will be just FAR2 and so for the time being
            // just don't allow users to select anything else (so not changing the current value from true).
            // when the time comes just uncomment the following line.
            $scope.hideStrategies = $scope.project.strategy_sources.length === 1 && $scope.project.strategy_sources[0] === 'niacs_strategy';
            return;
        }
        $log.debug("Loading geojson",$scope.geoJsonToLoad[0]);
        $scope.loadStatus = "Loading data for "+$scope.geoJsonToLoad[0].label+"...";
        var geoJsonUrl = $scope.geoJsonToLoad[0].geojson_buffered && $scope.geoJsonToLoad[0].geojson_buffered.self ? $scope.geoJsonToLoad[0].geojson_buffered.self : $scope.geoJsonToLoad[0].geojson.self;
        $http.get(geoJsonUrl).then(function(response){
            if(response.status == 200) {
                var json = response.data;
                if(json.type === 'Topology') {
                    $log.debug('Converting topojson to geojson');
                    json = topojson.feature(json,json.objects[Object.keys(json.objects)[0]]);
                }
                if($scope.geoJsonToLoad[0].id > 0 && json.features && json.features.length == 1) {
                    json.features[0].properties.niacsRegion = $scope.geoJsonToLoad[0]; // store the region object in the map data
                }
                var features = $scope.map.data.addGeoJson(json);
                if($scope.geoJsonToLoad[0].id === -1) {
                    $scope.stateFeatures = features;
                } else {
                    if(!$scope.varFeatures) {
                        $scope.varFeatures = [];
                    }
                    $scope.varFeatures = $scope.varFeatures.concat(features);
                }
                $scope.geoJsonToLoad = $scope.geoJsonToLoad.slice(1,$scope.geoJsonToLoad.length);
                doLoadGeoJson();
            }
        });
    }
    function initMap() {
        $scope.mapCanvas = document.getElementById('map-canvas');
        $scope.map = new google.maps.Map($scope.mapCanvas, {
          zoom: 4,
          center: new google.maps.LatLng(38.8402805, -97.61142369999999),
          streetViewControl: false
        });
        /*
        // picks up clicks on any area where we've over-laied geoJson data.
        $scope.map.data.addListener('click',function(event){
            $log.debug('data.click',event);
        });
        // with overlays this only happens if they click outside of the overlay
        // area.. (i.e. a location they can't put a marker anyway)
        google.maps.event.addListener($scope.map,'click',function(event){
            $log.debug('map.click',event);
        });
        */
        // set some defaults so while the map is drawn it looks consistent
        var dfltStyle = {strokeWeight:1,strokeColor:'#ffffff',fillColor:'#c0c5b8'};
        if(!niacs.DEBUG) {
            dfltStyle.strokeOpacity = 0;
            dfltStyle.fillOpacity = 0;
        }
        $scope.map.data.setStyle(dfltStyle);
        NiacsVulnAssmntRegion.query(function(results){
            $scope.regions = results.list;
            var toLoad = [{label:'US States',id:-1,geojson:{self:niacs.ModuleUrl+'/map-data/us-states.topojson'}}];
            angular.forEach($scope.regions,function(region){
                if(region.geojson && region.geojson.self) {
                    toLoad.push(region);
                }
            });
            $scope.geoJsonToLoad = toLoad;
            doLoadGeoJson();
        });
    }
    $scope.ok = function() {
        $scope.map = null;
        // allowing commas on input but strip them out on save.
        if(angular.isString($scope.project.acres) && $scope.project.acres.indexOf(',') !== -1) {
            $scope.project.acres = parseInt($scope.project.acres.replace(',',''));
        } else if(!$scope.project.acres) {
            $scope.project.acres = null; // remove
        }
        if($scope.project.id) { // update
            $scope.project.$update(function(project){
                $uibModalInstance.close(project);
            });
        } else { // create
            ProjectService.initProject($scope.project).then(function(p){
                p.$save(function(project){
                    $log.debug('Creating new property',project);
                    $uibModalInstance.close(project);
                });
            });
        }
    };
    $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };
    // this works but is an odd "workaround" to an issue where the map is
    // hosed if it's re-opened, delay the initialization of the map by half
    // a second...
    $timeout(initMap,500);
}])
.controller('CourseMaterialsDialogCtrl',['$scope','$uibModalInstance','$log','CourseOfferingService','theProject',function($scope,$uibModalInstance,$log,CourseOfferingService,theProject){
    $scope.dismiss = $uibModalInstance.dismiss;
    $scope.project = theProject;
    CourseOfferingService.getForProject(theProject).then(function(offering){
        $scope.offering = offering;
        // need to order materials based on the menu layout otherwise if
        // just using keys they will show up all jumbled up..
        var materials = [];
        function menu_functor(obj) {
            return function(key) {
                var value = obj[key];
                if(angular.isObject(value)) {
                    Object.keys(value).forEach(menu_functor(value));
                } else if(offering.materials[value]) {
                    materials.push(offering.materials[value]);
                }
            };
        }
        Object.keys(niacs.menu).forEach(menu_functor(niacs.menu));
        // for some a/b steps the NIACS team will cut/paste the course materials
        // eliminate duplicates.  for some reason some text representations mix
        // space and non-breaking space (charcode 160) so focing nbsp to ' '
        // so comparisons work.
        // this is a somewhat low-rent solution to this duplication issue.
        $scope.materials = (function(materials){
            var nbsp = String.fromCharCode(160),
                normalize = function(s) {
                    return s.trim().split('').map(function(c) { return c === nbsp ? ' ' : c; }).join('');
                },
                contents = [],
                $elm = ($||jQuery)('<div />');
            return materials.filter(function(m) {
                var c = normalize($elm.html(m.content).text());
                if(contents.indexOf(c) !== -1) {
                    $log.debug('discarding duplicate course materials for '+m.key+'/'+m.title);
                    return false;
                }
                contents.push(c);
                return true;
            });
        })(materials);
    });
}])
.controller('ProjectDashboardCtrl',['$scope','$q','$uibModal','ProjectService','NiacsProject','NiacsVulnAssmntRegion','AutoSaveService','DialogService','Course','PaneStateService',
    function($scope,$q,$uibModal,ProjectService,NiacsProject,NiacsVulnAssmntRegion,AutoSaveService,DialogService,Course,PaneStateService) {
    function reloadProjects() {
        var def = $q.defer();
        ProjectService.list().then(function(projects) {
            var cache = {};
            projects.forEach(function(project) {
                var vid = project.vuln_region;
                if(!(project.$vuln_region = cache[vid])) {
                    project.$vuln_region = cache[vid] = NiacsVulnAssmntRegion.get({id:vid});
                }
            });
            def.resolve($scope.projects = projects);
        });
        return def.promise;
    }
    reloadProjects();
    Course.enrolled(function(response) {
        $scope.enrolledCourses = response;
    });
    $scope.courseMaterials = function(project) {
        $uibModal.open({
            templateUrl: 'partials/dialogs/course-materials.html',
            controller: 'CourseMaterialsDialogCtrl',
            windowClass: 'niacs-course-materials',
            backdrop: 'static',
            keyboard: false,
            size: 'huge',
            resolve: {
                theProject: function() { return project; }
            }
        });
    };
    $scope.createProject = function(course) {
        var modalInstance = $uibModal.open({
            templateUrl: 'partials/dialogs/create-edit-project.html',
            controller: 'ProjectDialogCtrl',
            windowClass: 'niacs-project-dialog',
            backdrop: 'static', // don't allow close by clicking outside dialog
            keyboard: false, // ESC doesn't dismiss
            resolve: {
                theProject: function() {
                    var theProject = new NiacsProject({version:niacs.PROJECT_VERSION});
                    if(course) {
                        // this is a little internal knowledge, the REST resource exposes
                        // these attributes under a sub-object 'training' but..
                        theProject.course = course.id;
                        theProject.course_offering = course.version;
                    }
                    return theProject;
                }
            }
        });
        modalInstance.result.then(function(project){
            reloadProjects().then(function(){
                var paneId = 'project.'+project.id;
                PaneStateService.getState('dashboard',paneId); // won't be displayed yet, pre-emptively create it's view state
                PaneStateService.activate(paneId);
            });
        },function(){});
    };
    $scope.editProject = function(project) {
        var modalInstance = $uibModal.open({
            templateUrl: 'partials/dialogs/create-edit-project.html',
            controller: 'ProjectDialogCtrl',
            windowClass: 'niacs-project-dialog',
            backdrop: 'static', // don't allow close by clicking outside dialog
            keyboard: false, // ESC doesn't dismiss
            resolve: {
                theProject: function() { return NiacsProject.get({id: project.id},function(p) {
                        p.$vuln_region = project.$vuln_region;
                    });
                }
            }
        });
        modalInstance.result.then(function(project){
            reloadProjects();
        },function(){});
    };
    $scope.deleteProject = function(p) {
        // load the whole project so we can tell them a bit about what they're about
        // to delete.
        NiacsProject.get({id: p.id},function(project) {
            var dialogContents = {
                  message: 'Are you sure you want to remove the property '+(project.label)+'?',
                  warning: 'This cannot be undone.',
                  okText: 'Yes, remove it',
                  cancelText: 'No, keep it',
                  conditions: []
                },cnt;
            if(project.units && project.units.length) {
                dialogContents.conditions.push(project.units.length+' Management Topics have been identified.');
            }
            if( (cnt=niacs.countGoals(project,true)) > 0) {
                dialogContents.conditions.push(cnt+' goals have been defined.');
            }
            if( (cnt=niacs.countObjectives(project,true)) > 0) {
                dialogContents.conditions.push(cnt+' objectives have been defined.');
            }
            if(project.training && project.training.course && project.training.course_offering) {
                dialogContents.conditions.push('1 associated course offerings have been found.');
                dialogContents.warning += '  This project is associated with a course offering. ';
                dialogContents.warning += 'If you delete it you will no longer have access ';
                dialogContents.warning += 'to the course materials.';
                if(project.training.homework) {
                    cnt = Object.keys(project.training.homework).reduce(function(c,key){
                        return c + Object.keys(project.training.homework[key]).length;
                    },0);
                    if(cnt > 0) {
                        dialogContents.conditions.push(cnt+' homework answers have been supplied.');
                        dialogContents.warning += '  In addition instructors will no longer have access ';
                        dialogContents.warning += 'to the homework answers you may have supplied.';
                    }
                }
            }
            DialogService.safe(dialogContents).then(function() {
                AutoSaveService.startSaving();
                project.$delete(function(response){
                    AutoSaveService.saveComplete();
                    reloadProjects().then(function(projects) {
                        if(projects && projects.length) {
                            // activate the first project
                            PaneStateService.activate('project.'+projects[0].id);
                        }
                    });
                });
            });
        });
    };
}]);
